// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Navigation Component Theme Styles
 *
 * Theme-aware styles for the main navigation bar.
 * Uses CSS custom properties from theme.css for light/dark mode support.
 */

/* ============================================
   NAVIGATION BAR
   ============================================ */

.cfn-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  background: var(--cfn-nav-bg);
  color: var(--cfn-nav-text);
  box-shadow: var(--cfn-shadow-md);
  border-bottom: 1px solid var(--cfn-nav-border);
  --cfn-nav-height: 60px;
}

/* Short landscape (phones turned sideways): slim the nav to reclaim vertical space */
@media (orientation: landscape) and (max-height: 600px) {
  .cfn-nav {
    --cfn-nav-height: 48px;
  }
}

.cfn-nav-container {
  padding: 0 1rem;
}

.cfn-nav-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: var(--cfn-nav-height);
}

/* ============================================
   LOGO
   ============================================ */

.cfn-nav-logo {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0.125rem 0;
  flex-shrink: 0;
}

.cfn-nav-logo-img {
  height: 1.75rem;
  max-height: 28px;
  width: auto;
  min-width: 0;
  -o-object-fit: contain;
     object-fit: contain;
  transition: filter 0.2s ease, height 0.2s ease;
}

/* Larger logo on wider screens */
@media (min-width: 400px) {
  .cfn-nav-logo-img {
    height: 2rem;
    max-height: 32px;
  }
}

@media (min-width: 540px) {
  .cfn-nav-logo-img {
    height: 2.5rem;
    max-height: 40px;
  }
}

@media (min-width: 768px) {
  .cfn-nav-logo-img {
    height: 3rem;
    max-height: 48px;
  }
}

@media (min-width: 1024px) {
  .cfn-nav-logo-img {
    height: 3.5rem;
    max-height: 56px;
  }
}

/* Light theme logo filter: inverts the logo so dark becomes light and vice versa,
   then adjusts hue to maintain the orange brand colour */
.cfn-nav-logo-light {
  filter: invert(1) hue-rotate(180deg);
}

/* ============================================
   NAVIGATION LINKS
   ============================================ */

.cfn-nav-link {
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  color: var(--cfn-nav-link);
  transition: all 0.15s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.cfn-nav-link:hover {
  color: var(--cfn-nav-link-hover);
  background: var(--cfn-nav-link-hover-bg);
}

.cfn-nav-link-mobile {
  display: block;
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  font-size: 1rem;
  color: var(--cfn-nav-link);
  transition: all 0.15s ease;
  text-decoration: none;
}

.cfn-nav-link-mobile:hover {
  color: var(--cfn-nav-link-hover);
  background: var(--cfn-nav-link-hover-bg);
}

/* ============================================
   USER MENU BUTTON
   ============================================ */

.cfn-nav-user-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  color: var(--cfn-nav-link);
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.15s ease;
}

.cfn-nav-user-btn:hover {
  color: var(--cfn-nav-link-hover);
  background: var(--cfn-nav-link-hover-bg);
}

/* ============================================
   DROPDOWN MENU
   ============================================ */

.cfn-nav-dropdown {
  position: absolute;
  right: 0;
  margin-top: 0.5rem;
  width: 14rem;
  border-radius: 0.375rem;
  background: var(--cfn-nav-dropdown-bg);
  color: var(--cfn-nav-dropdown-text);
  border: 1px solid var(--cfn-nav-dropdown-border);
  box-shadow: var(--cfn-shadow-lg);
  z-index: 9999;
}

.cfn-nav-dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  color: var(--cfn-nav-dropdown-text);
  background: transparent;
  border: none;
  text-align: left;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.15s ease;
}

.cfn-nav-dropdown-item:hover {
  background: var(--cfn-nav-dropdown-hover);
}

.cfn-nav-dropdown-divider {
  border-top: 1px solid var(--cfn-nav-dropdown-border);
  margin: 0.25rem 0;
}

/* ============================================
   MOBILE MENU
   ============================================ */

.cfn-nav-mobile-btn {
  padding: 0.5rem;
  border-radius: 0.375rem;
  color: var(--cfn-nav-link);
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.15s ease;
}

.cfn-nav-mobile-btn:hover {
  color: var(--cfn-nav-link-hover);
  background: var(--cfn-nav-link-hover-bg);
}

.cfn-nav-mobile-menu {
  padding-bottom: 1rem;
  max-height: calc(100vh - var(--cfn-nav-height));
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}

@supports (height: 100dvh) {
  .cfn-nav-mobile-menu {
    max-height: calc(100dvh - var(--cfn-nav-height));
  }
}

.cfn-nav-mobile-section {
  border-top: 1px solid var(--cfn-nav-mobile-border);
  margin-top: 1rem;
  padding-top: 1rem;
}

.cfn-nav-mobile-user {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.75rem;
}

.cfn-nav-mobile-email {
  font-size: 0.875rem;
  color: var(--cfn-nav-link-muted);
}

/* ============================================
   THEME TOGGLE BUTTON
   ============================================ */

.cfn-nav-theme-toggle {
  padding: 0.5rem;
  border-radius: 0.375rem;
  color: var(--cfn-nav-link);
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cfn-nav-theme-toggle:hover {
  color: var(--cfn-nav-link-hover);
  background: var(--cfn-nav-link-hover-bg);
}

/* ============================================
   THEME VARIABLES - DARK MODE
   ============================================ */

:root,
.theme-dark {
  /* Navigation bar */
  --cfn-nav-bg: #000000;
  --cfn-nav-text: #ffffff;
  --cfn-nav-border: rgba(255, 255, 255, 0.1);

  /* Navigation links */
  --cfn-nav-link: #d1d5db;
  --cfn-nav-link-hover: #ffffff;
  --cfn-nav-link-hover-bg: rgba(255, 255, 255, 0.1);
  --cfn-nav-link-muted: #9ca3af;

  /* Dropdown menu */
  --cfn-nav-dropdown-bg: var(--cfn-bg-secondary);
  --cfn-nav-dropdown-text: var(--cfn-text-primary);
  --cfn-nav-dropdown-border: var(--cfn-border);
  --cfn-nav-dropdown-hover: var(--cfn-bg-elevated);

  /* Mobile menu */
  --cfn-nav-mobile-border: rgba(255, 255, 255, 0.15);
}

/* ============================================
   THEME VARIABLES - LIGHT MODE
   ============================================ */

.theme-light {
  /* Navigation bar */
  --cfn-nav-bg: #ffffff;
  --cfn-nav-text: #0f172a;
  --cfn-nav-border: rgba(0, 0, 0, 0.1);

  /* Navigation links */
  --cfn-nav-link: #4b5563;
  --cfn-nav-link-hover: #0f172a;
  --cfn-nav-link-hover-bg: rgba(0, 0, 0, 0.05);
  --cfn-nav-link-muted: #6b7280;

  /* Dropdown menu */
  --cfn-nav-dropdown-bg: var(--cfn-bg-primary);
  --cfn-nav-dropdown-text: var(--cfn-text-primary);
  --cfn-nav-dropdown-border: var(--cfn-border);
  --cfn-nav-dropdown-hover: var(--cfn-bg-tertiary);

  /* Mobile menu */
  --cfn-nav-mobile-border: rgba(0, 0, 0, 0.1);
}

/* ============================================
   RESPONSIVE UTILITIES
   ============================================ */

/* Desktop elements - visible at all sizes now with progressive overflow */
.cfn-nav-desktop {
  display: flex;
}

/* Mobile menu toggle - hidden (we use overflow menu instead) */
.cfn-nav-mobile-toggle {
  display: none;
}

/* Primary nav items container - always visible with overflow handling */
.cfn-nav-primary {
  display: flex;
  position: relative;
  flex: 1;
  margin-left: 0.5rem;
  align-items: center;
  gap: 0.25rem;
  overflow: hidden;
  min-width: 0;
}

@media (min-width: 480px) {
  .cfn-nav-primary {
    margin-left: 0.75rem;
  }
}

@media (min-width: 768px) {
  .cfn-nav-primary {
    margin-left: 1rem;
  }
}

/* Dropdown section labels */
.cfn-nav-dropdown-label {
  padding: 0.5rem 1rem 0.25rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--cfn-nav-link-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

/* Mobile menu - now hidden (replaced by overflow menu) */
.cfn-nav-mobile-menu {
  display: none;
}

/* Hide user email text and chevron on narrow screens - show only icon */
.cfn-nav-user-btn span,
.cfn-nav-user-btn .cfn-nav-user-chevron {
  display: none;
}

@media (min-width: 768px) {
  .cfn-nav-user-btn span,
  .cfn-nav-user-btn .cfn-nav-user-chevron {
    display: inline;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/navigation.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;;iDAEiD;;AAEjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6BAA6B;EAC7B,0BAA0B;EAC1B,gCAAgC;EAChC,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA,qFAAqF;AACrF;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,sBAAmB;KAAnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA,iCAAiC;AACjC;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;yDACyD;AACzD;EACE,oCAAoC;AACtC;;AAEA;;iDAEiD;;AAEjD;EACE,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,0BAA0B;EAC1B,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;;iDAEiD;;AAEjD;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,sCAAsC;EACtC,mCAAmC;EACnC,gDAAgD;EAChD,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,mCAAmC;EACnC,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;EACpD,iBAAiB;AACnB;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,uBAAuB;EACvB,0BAA0B;EAC1B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,+CAA+C;EAC/C,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,uBAAuB;EACvB,0BAA0B;EAC1B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;;iDAEiD;;AAEjD;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,0CAA0C;;EAE1C,qBAAqB;EACrB,uBAAuB;EACvB,6BAA6B;EAC7B,iDAAiD;EACjD,6BAA6B;;EAE7B,kBAAkB;EAClB,8CAA8C;EAC9C,gDAAgD;EAChD,4CAA4C;EAC5C,gDAAgD;;EAEhD,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;;iDAEiD;;AAEjD;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,oCAAoC;;EAEpC,qBAAqB;EACrB,uBAAuB;EACvB,6BAA6B;EAC7B,4CAA4C;EAC5C,6BAA6B;;EAE7B,kBAAkB;EAClB,4CAA4C;EAC5C,gDAAgD;EAChD,4CAA4C;EAC5C,gDAAgD;;EAEhD,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;;iDAEiD;;AAEjD,0EAA0E;AAC1E;EACE,aAAa;AACf;;AAEA,+DAA+D;AAC/D;EACE,aAAa;AACf;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,4BAA4B;AAC5B;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,yDAAyD;AACzD;EACE,aAAa;AACf;;AAEA,wEAAwE;AACxE;;EAEE,aAAa;AACf;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF","sourcesContent":["/**\n * Navigation Component Theme Styles\n *\n * Theme-aware styles for the main navigation bar.\n * Uses CSS custom properties from theme.css for light/dark mode support.\n */\n\n/* ============================================\n   NAVIGATION BAR\n   ============================================ */\n\n.cfn-nav {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 50;\n  background: var(--cfn-nav-bg);\n  color: var(--cfn-nav-text);\n  box-shadow: var(--cfn-shadow-md);\n  border-bottom: 1px solid var(--cfn-nav-border);\n  --cfn-nav-height: 60px;\n}\n\n/* Short landscape (phones turned sideways): slim the nav to reclaim vertical space */\n@media (orientation: landscape) and (max-height: 600px) {\n  .cfn-nav {\n    --cfn-nav-height: 48px;\n  }\n}\n\n.cfn-nav-container {\n  padding: 0 1rem;\n}\n\n.cfn-nav-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: var(--cfn-nav-height);\n}\n\n/* ============================================\n   LOGO\n   ============================================ */\n\n.cfn-nav-logo {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  padding: 0.125rem 0;\n  flex-shrink: 0;\n}\n\n.cfn-nav-logo-img {\n  height: 1.75rem;\n  max-height: 28px;\n  width: auto;\n  min-width: 0;\n  object-fit: contain;\n  transition: filter 0.2s ease, height 0.2s ease;\n}\n\n/* Larger logo on wider screens */\n@media (min-width: 400px) {\n  .cfn-nav-logo-img {\n    height: 2rem;\n    max-height: 32px;\n  }\n}\n\n@media (min-width: 540px) {\n  .cfn-nav-logo-img {\n    height: 2.5rem;\n    max-height: 40px;\n  }\n}\n\n@media (min-width: 768px) {\n  .cfn-nav-logo-img {\n    height: 3rem;\n    max-height: 48px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .cfn-nav-logo-img {\n    height: 3.5rem;\n    max-height: 56px;\n  }\n}\n\n/* Light theme logo filter: inverts the logo so dark becomes light and vice versa,\n   then adjusts hue to maintain the orange brand colour */\n.cfn-nav-logo-light {\n  filter: invert(1) hue-rotate(180deg);\n}\n\n/* ============================================\n   NAVIGATION LINKS\n   ============================================ */\n\n.cfn-nav-link {\n  padding: 0.5rem 0.75rem;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  color: var(--cfn-nav-link);\n  transition: all 0.15s ease;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.cfn-nav-link:hover {\n  color: var(--cfn-nav-link-hover);\n  background: var(--cfn-nav-link-hover-bg);\n}\n\n.cfn-nav-link-mobile {\n  display: block;\n  padding: 0.5rem 0.75rem;\n  border-radius: 0.375rem;\n  font-size: 1rem;\n  color: var(--cfn-nav-link);\n  transition: all 0.15s ease;\n  text-decoration: none;\n}\n\n.cfn-nav-link-mobile:hover {\n  color: var(--cfn-nav-link-hover);\n  background: var(--cfn-nav-link-hover-bg);\n}\n\n/* ============================================\n   USER MENU BUTTON\n   ============================================ */\n\n.cfn-nav-user-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  color: var(--cfn-nav-link);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.cfn-nav-user-btn:hover {\n  color: var(--cfn-nav-link-hover);\n  background: var(--cfn-nav-link-hover-bg);\n}\n\n/* ============================================\n   DROPDOWN MENU\n   ============================================ */\n\n.cfn-nav-dropdown {\n  position: absolute;\n  right: 0;\n  margin-top: 0.5rem;\n  width: 14rem;\n  border-radius: 0.375rem;\n  background: var(--cfn-nav-dropdown-bg);\n  color: var(--cfn-nav-dropdown-text);\n  border: 1px solid var(--cfn-nav-dropdown-border);\n  box-shadow: var(--cfn-shadow-lg);\n  z-index: 9999;\n}\n\n.cfn-nav-dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  color: var(--cfn-nav-dropdown-text);\n  background: transparent;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  text-decoration: none;\n  transition: background 0.15s ease;\n}\n\n.cfn-nav-dropdown-item:hover {\n  background: var(--cfn-nav-dropdown-hover);\n}\n\n.cfn-nav-dropdown-divider {\n  border-top: 1px solid var(--cfn-nav-dropdown-border);\n  margin: 0.25rem 0;\n}\n\n/* ============================================\n   MOBILE MENU\n   ============================================ */\n\n.cfn-nav-mobile-btn {\n  padding: 0.5rem;\n  border-radius: 0.375rem;\n  color: var(--cfn-nav-link);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.cfn-nav-mobile-btn:hover {\n  color: var(--cfn-nav-link-hover);\n  background: var(--cfn-nav-link-hover-bg);\n}\n\n.cfn-nav-mobile-menu {\n  padding-bottom: 1rem;\n  max-height: calc(100vh - var(--cfn-nav-height));\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n}\n\n@supports (height: 100dvh) {\n  .cfn-nav-mobile-menu {\n    max-height: calc(100dvh - var(--cfn-nav-height));\n  }\n}\n\n.cfn-nav-mobile-section {\n  border-top: 1px solid var(--cfn-nav-mobile-border);\n  margin-top: 1rem;\n  padding-top: 1rem;\n}\n\n.cfn-nav-mobile-user {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5rem 0.75rem;\n}\n\n.cfn-nav-mobile-email {\n  font-size: 0.875rem;\n  color: var(--cfn-nav-link-muted);\n}\n\n/* ============================================\n   THEME TOGGLE BUTTON\n   ============================================ */\n\n.cfn-nav-theme-toggle {\n  padding: 0.5rem;\n  border-radius: 0.375rem;\n  color: var(--cfn-nav-link);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cfn-nav-theme-toggle:hover {\n  color: var(--cfn-nav-link-hover);\n  background: var(--cfn-nav-link-hover-bg);\n}\n\n/* ============================================\n   THEME VARIABLES - DARK MODE\n   ============================================ */\n\n:root,\n.theme-dark {\n  /* Navigation bar */\n  --cfn-nav-bg: #000000;\n  --cfn-nav-text: #ffffff;\n  --cfn-nav-border: rgba(255, 255, 255, 0.1);\n\n  /* Navigation links */\n  --cfn-nav-link: #d1d5db;\n  --cfn-nav-link-hover: #ffffff;\n  --cfn-nav-link-hover-bg: rgba(255, 255, 255, 0.1);\n  --cfn-nav-link-muted: #9ca3af;\n\n  /* Dropdown menu */\n  --cfn-nav-dropdown-bg: var(--cfn-bg-secondary);\n  --cfn-nav-dropdown-text: var(--cfn-text-primary);\n  --cfn-nav-dropdown-border: var(--cfn-border);\n  --cfn-nav-dropdown-hover: var(--cfn-bg-elevated);\n\n  /* Mobile menu */\n  --cfn-nav-mobile-border: rgba(255, 255, 255, 0.15);\n}\n\n/* ============================================\n   THEME VARIABLES - LIGHT MODE\n   ============================================ */\n\n.theme-light {\n  /* Navigation bar */\n  --cfn-nav-bg: #ffffff;\n  --cfn-nav-text: #0f172a;\n  --cfn-nav-border: rgba(0, 0, 0, 0.1);\n\n  /* Navigation links */\n  --cfn-nav-link: #4b5563;\n  --cfn-nav-link-hover: #0f172a;\n  --cfn-nav-link-hover-bg: rgba(0, 0, 0, 0.05);\n  --cfn-nav-link-muted: #6b7280;\n\n  /* Dropdown menu */\n  --cfn-nav-dropdown-bg: var(--cfn-bg-primary);\n  --cfn-nav-dropdown-text: var(--cfn-text-primary);\n  --cfn-nav-dropdown-border: var(--cfn-border);\n  --cfn-nav-dropdown-hover: var(--cfn-bg-tertiary);\n\n  /* Mobile menu */\n  --cfn-nav-mobile-border: rgba(0, 0, 0, 0.1);\n}\n\n/* ============================================\n   RESPONSIVE UTILITIES\n   ============================================ */\n\n/* Desktop elements - visible at all sizes now with progressive overflow */\n.cfn-nav-desktop {\n  display: flex;\n}\n\n/* Mobile menu toggle - hidden (we use overflow menu instead) */\n.cfn-nav-mobile-toggle {\n  display: none;\n}\n\n/* Primary nav items container - always visible with overflow handling */\n.cfn-nav-primary {\n  display: flex;\n  position: relative;\n  flex: 1;\n  margin-left: 0.5rem;\n  align-items: center;\n  gap: 0.25rem;\n  overflow: hidden;\n  min-width: 0;\n}\n\n@media (min-width: 480px) {\n  .cfn-nav-primary {\n    margin-left: 0.75rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .cfn-nav-primary {\n    margin-left: 1rem;\n  }\n}\n\n/* Dropdown section labels */\n.cfn-nav-dropdown-label {\n  padding: 0.5rem 1rem 0.25rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--cfn-nav-link-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n/* Mobile menu - now hidden (replaced by overflow menu) */\n.cfn-nav-mobile-menu {\n  display: none;\n}\n\n/* Hide user email text and chevron on narrow screens - show only icon */\n.cfn-nav-user-btn span,\n.cfn-nav-user-btn .cfn-nav-user-chevron {\n  display: none;\n}\n\n@media (min-width: 768px) {\n  .cfn-nav-user-btn span,\n  .cfn-nav-user-btn .cfn-nav-user-chevron {\n    display: inline;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
